import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class TranslateHandler implements MissingTranslationHandler {
  private response = 'No translation';
  handle(params: MissingTranslationHandlerParams) {
    return this.response;
  }
}
